
// Utils

export const REQUIRED_IDENTIFIER = " *";

export const LOADING_MESSAGE = "Chargement...";

export const REQUIRED_MESSAGE = "Obligatoire";


// Service worker wrapper

export const NEW_VERSION_MESSAGE = "Une nouvelle version pour Le Réseau Scolaire est disponible. Installez-la !";

export const NEW_VERSION_TITLE = "Nouvelle version disponible !"

export const INSTALLING_NEW_VERSION_MESSAGE = "En cours d'installation...";


// Buttons

export const INSTALL_BUTTON_TITLE = "Installer"


// IMAGE

export const ImageURL = "https://henri-bo.slapp.me/uploads/"